import React, { useEffect, useState } from "react";

export default function ResponseFiles() {
  const [archivos, setArchivos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/responseFiles`)
      .then(res => res.json())
      .then(data => {
        setArchivos(data.files || []);
        setLoading(false);
      })
      .catch(err => {
        setError(err.message);
        setLoading(false);
      });
  }, []);

  if (loading) return <p>Cargando archivos...</p>;
  if (error) return <p style={{ color: "red" }}>Error: {error}</p>;

  return (
    <div style={{ padding: "20px" }}>
      <h3>ARCHIVOS DE RESPUESTA</h3>
      <ul>
        {archivos.map((item, index) => (
          <li key={index}>
            <a href={item.url} target="_blank" rel="noopener noreferrer">
              {item.nombre}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}